/***
 * Editor.js
 * Description: renders the text editor
 * /

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useContext } from "react";
import styled from "@emotion/styled";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { Controlled as ControlledEditor } from "react-codemirror2";

import ExecuteButton from "./ExecuteButton";
import ImportButton from "./ImportButton";

import { context } from "../context/GlobalState";

import { Text } from "@chakra-ui/react";

const Editor = () => {
  const { state, dispatch } = useContext(context);

  // Load the sourceCode from localStorage at the first load of the page
  useEffect(() => {
    const savedSourceCode = localStorage.getItem("sourceCode");
    if (savedSourceCode) {
      dispatch({ type: "SET_EDITOR_CODE", payload: savedSourceCode });
    } else {
      dispatch({
        type: "SET_EDITOR_CODE",
        payload: 'HAI\n\tVISIBLE "Hello World!"\nKTHXBYE',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // Wrapper -> just a styled div
    <Wrapper>
      {/* Header -> another styled div */}
      <Header>
        <Text>{state.filename ? state.filename : "LOLCODE 🌭"}</Text>
        <div>
          {/* ImportButton setData prop is a function that sets the pre-execute source code */}
          <ImportButton />
          {/* ExecuteButton props are isExecute state and setExecute function for setting it */}
          <ExecuteButton />
        </div>
      </Header>
      <StyledEditor
        // onBeforeChange calls an anonymous function before the editor changes
        onBeforeChange={(editor, data, value) => {
          dispatch({ type: "SET_EDITOR_CODE", payload: value }); // updates the data state to the value of the editor
        }}
        onChange={(editor, data, value) => {
          //saves changes to localStorage everytime state.editorCode changes
          localStorage.setItem("sourceCode", state.editorCode);
        }}
        value={state.editorCode} // sets the data state as the value of the Editor component
        options={OPTIONS} // options for default properties of CodeMirror
      />
    </Wrapper>
  );
};

// Options for StyledEditor
const OPTIONS = {
  lineWrapping: true,
  lineNumbers: true,
  tabSize: 2,
  indentWithTabs: true,
};

// STYLES
const Wrapper = styled.div`
  min-height: 100vh;

  background-color: #0f202d;
  padding: 2rem 1.5rem 0 0.5rem;
`;
const Header = styled.div`
  color: #ffffff;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  padding-left: 1.5rem;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  bottom: 0px;
`;
const StyledEditor = styled(ControlledEditor)`
  .CodeMirror {
    height: 83vh;
    line-height: 1.5;
    background-color: #0f202d;
    color: #ffffff;
    font-size: 16px;
    font-family: "Consolas", "Courier New", Courier, monospace;
  }

  .CodeMirror-gutters {
    background-color: #0f202d;
    border-right-color: #0f202d;
  }
  .CodeMirror-wrap pre {
    word-break: break-word;
  }

  .CodeMirror-cursor {
    border-left: 1px solid #ffffff;
  }
`;

export default Editor;
